import styled, { css } from 'styled-components';
import { Body4, Headline3 } from './../../../app/common/typography';

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.oxfordBlue};
  z-index: 1002;
`;

export const Wrapper = styled.div``;

export const Cards = styled.div`
  margin-bottom: 88px;
  margin-top: 88px;
  padding: ${({ theme }) => theme.spacing.m};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.xm};
`;

export const CountDownTimer = styled(Body4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.redCrayola};
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const QuestionTitle = styled(Headline3)`
  text-align: center;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const AnswerChoices = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xm};
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const Answer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
`;

export const HeaderText = styled(Headline3)(
  ({ theme, isCorrect }) => css`
    color: ${isCorrect ? theme.colors.verdigris : theme.colors.redCrayola};
  `
);

export const InactivityContainer = styled(Body4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.redCrayola};
  margin-top: ${({ theme }) => theme.spacing.m};
`;

export const AnswerExplanation = styled(Body4)`
  margin: ${({ theme }) => theme.spacing.md} 0;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const CorrectAnswerSection = styled.div`
  margin: ${({ theme }) => theme.spacing.md} 0;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

export const PictureWrapper = styled.div`
  width: ${({ theme }) => theme.width.full};
  height: 200px;
  max-height: 200px;
`;

export const ImgContent = styled.img`
  object-fit: cover;
  object-position: center;
  width: ${({ theme }) => theme.width.full};
  height: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

export const ButtonBlock = styled.div`
  width: ${({ theme }) => theme.width.half};
`;

export const WrapperResult = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.xm};
`;

export const StarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${({ theme }) => theme.spacing.xs};
  svg {
    fill: ${({ theme }) => theme.colors.tangerine};
  }
`;

export const ContentQuiz = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 88px;
  padding: ${({ theme }) => theme.spacing.m};
`;
